import type { MaybeRef } from "vue"
import type { EventVaultType } from "@/models"
import * as Sentry from "@sentry/vue"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import z from "zod"
import { v1 } from "@/axios"

export async function listDomains(eventType?: EventVaultType) {
  const endpoint = `/domain`

  const response = await v1.get(endpoint, { params: { eventType } })

  const schema = z.array(z.string())

  const result = schema.safeParse(response.data.data)

  if (!result.success) {
    const message = "Failed to validate API response schema"
    Sentry.logger.error(message, {
      raw: response.data.data,
      endpoint,
      method: "get",
    })

    throw new Error(message)
  }

  return result.data
}

const LIST_DOMAINS_QUERY_KEY = "listDomains"

export function useListDomains(eventType?: MaybeRef<EventVaultType | undefined>, enabled?: MaybeRef<boolean>) {
  return useQuery({
    queryKey: [LIST_DOMAINS_QUERY_KEY, eventType],
    queryFn: () => listDomains(toValue(eventType)),
    enabled,
  })
}
